import { ModelHelper } from '../classes/model-helper';

/**
 * File data class
 */
export class FileData {
	// Properties
	fileName: string;
	fileUid: string;
	link: string;
	md5Hash: string;
	state: number;

	/**
	 * Static mapping function
	 */
	static map(data: any, item: FileData = new FileData()): FileData {
		return item.map(data);
	}

	/**
	 * Non static mapping function
	 */
	public map(data: any): FileData {
		ModelHelper.map(data, this, 'fileName');
		ModelHelper.map(data, this, 'fileUid');
		ModelHelper.map(data, this, 'link');
		ModelHelper.map(data, this, 'md5Hash');
		ModelHelper.map(data, this, 'state');

		return this;
	}
}
